import {
  updateField
} from 'vuex-map-fields';

export default {
  updateField,

  setWhereType(state, whereType) {
    state.whereType = whereType;
  },

  setAutoCompleteUrl(state, autoCompleteUrl) {
    state.autoCompleteUrl = autoCompleteUrl;
  },

  setSuggestions(state, suggestions) {
    state.suggestions = suggestions;
  },

  setDates(state, dates) {
    state.dates = dates;
  },

  setTypes(state, types) {
    state.types = types;
  },

  setDepartures(state, departures) {
    state.departures = departures;
  }

}